exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tamanho[data-v-4e3984bd] {\r\n    width: 200px;\n}\r\n", ""]);

// exports
